import React, { Component } from 'react';
import $ from "jquery";

import "./../styles/formTextItem.css";
import SecurityPlanService from "../services/SecurityPlan.service";

export default class FormTextItem extends Component {
    state = {
        item: "",
        items: this.props.items,
        loading: true
    };
    updateItem = (e) => {
        this.setState({item: e.target.value});
    };
    addItem = async (e) => {
        e.preventDefault();
        const data = {
            text: this.state.item,
            categoryID: this.props.idCategory,
        }
        const response = await SecurityPlanService.post(data);

        if(response.data.message === 'POST_SECURITY_PLAN_SUCCESSFUL') {
            let newItems = this.state.items;
            newItems.unshift(response.data.item);
            this.setState({items: newItems, item: ""});
        } else {
            alert(`Error: ${response.data.message}`);
        }
    }
    removeItem = async (e) => {
        e.preventDefault();
        e.persist();

        const data = {
            UUID: this.state.items[e.target.name].UUID
        }
        const response = await SecurityPlanService.delete(data);
        
        if(response.data.message === 'DELETE_SECURITY_PLAN_SUCCESSFUL'){
            let newItems = this.state.items;
            newItems.splice(e.target.name, 1);
            this.setState({ items: newItems });
        } else {
            alert(`Error: ${response.data.message}`);
        }
        
    }

    componentDidUpdate(prevProps){
        if(prevProps.items.length !== this.props.items.length){
            const newItems = this.props.items.filter((item) => item.categoryID === this.props.idCategory);
            this.setState({loading: false, items: newItems});
        }
    }

    componentDidMount(){
        //Sobre el funcionamiento del modal
        var idModals=this.props.idCategory;
        $('#ModalFor'+idModals).css('display', 'block');
        $('#ModalFor'+idModals).hide();

        $('#OpenModal'+idModals).click(function(){
            $('#ModalFor'+idModals).fadeIn();
            $('body').css('overflow-y', 'hidden');
        });

        function closeModal(){
            $('#ModalFor'+idModals).fadeOut(function(){
                $('#textAreaModal'+idModals).val('');
                $('#textAreaModal'+idModals).css('height', '100px');
                $('#CharacterCounter'+idModals).html('0/250');
            });
            $('body').css('overflow-y', 'auto');
        }
        $('#CloseModalA'+idModals).click(closeModal);
        $('#CloseModalB'+idModals).click(closeModal);

        //Sobre el funcionamiento del textarea
        function textCounter(){
            $('#CharacterCounter'+idModals).html($(this).val().length+'/250');

            if($(this).val().length === 250){
                $('#CharacterCounter'+idModals).css('color', '#e43636');
            }else{
                $('#CharacterCounter'+idModals).css('color', 'rgba(0,0,0,0.87)');
            }
        }
        $('#textAreaModal'+idModals).keyup(textCounter);
        $('#textAreaModal'+idModals).keydown(textCounter);

        $('#textAreaModal'+idModals).each(function () {
            this.setAttribute('style', 'height:' + (this.scrollHeight) + 'px;overflow-y:hidden;');
          }).on('input', function () {
            this.style.height = 'auto';
            this.style.height = (this.scrollHeight) + 'px';
          });
        
        const items = this.props.items.filter((item) => item.categoryID === this.props.idCategory);
        this.setState({ loading: false, items });
    }

    render() {
        var dataReturn;
        if(this.state.items.length>0){
            dataReturn=<div className="itemsList">
                {
                    this.state.items.map((item, index) => {
                        return (
                            <form key={index} className="item" action="">
                                <div className="itemText"><p>{item.text}</p></div>
                                <input type="button" onClick={this.removeItem} name={index} value="DEL" id={'DelBTN'+index+'_'+this.props.idCategory}/>
                                <label htmlFor={'DelBTN'+index+'_'+this.props.idCategory} className="btn grey DeleteButton"><i className="material-icons-round">delete</i></label>
                            </form>
                        );
                    })
                }
            </div>
        }else{
            dataReturn=<p className="notFound">No hay ninguna nota para ver, comience escribiendo una.</p>
        }
        var dataLoader=<div className="LoadingContainer">
            <div className="loader"></div>    
        </div>

        return (
            <div className="card formTextItem">
                <h1>{this.props.title}</h1>
                <p className="description">{this.props.description}</p>
                <div className="ButtonAdd">
                    <button className="btn" id={'OpenModal'+this.props.idCategory}><i className="material-icons-round prefix">add</i>Escribir algo nuevo</button>
                </div>

                <div className="modal" id={'ModalFor'+this.props.idCategory}>
                    <div className="modalContent">
                        <form action="" className="card">
                            <div className="body-card">
                                <div className="TextAreaCard">
                                    <textarea onChange={this.updateItem} value={this.state.item} id={'textAreaModal'+this.props.idCategory} maxLength="250" placeholder="Escribe algo nuevo por acá..."></textarea>
                                    <p className="CharacterCounter" id={'CharacterCounter'+this.props.idCategory}>0/250</p>
                                </div>
                            </div>
                            <div className="end-card confirmFooter">
                                <div id={'CloseModalB'+this.props.idCategory}>CANCELAR</div>
                                <button onClick={this.addItem.bind(this)} id={'CloseModalA'+this.props.idCategory} className="btn">LISTO</button>
                            </div>
                        </form>
                    </div>
                </div>

                {this.state.loading ? dataLoader : dataReturn}
            </div>
        )
    }
}